import { createAction, props } from '@ngrx/store';
import { UserInfo } from './models';

export const setUserConfigs = createAction(
  '[User configs] set user data',
  props<{
    user: UserInfo;
  }>()
);
